function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { getImagePositionStyles } from "segments/desktop/core-components/images-grid/images-grid-service";
import { XS } from "constants/sizes";
import Title from "segments/desktop/core-components/title/title";
import VerticalTabs from "./tabs/tabs";
import { StyledVerticalTabsDesktopComponent } from "./vertical-tabs-desktop-component.scss";
import VerticalTab from "./tab/tab";
class VerticalTabsDesktopComponent extends PureComponent {
    tabsRenderer() {
        const { tabs, tabsColor, addTimeline, isDarkTheme, lineColor, tabContentRenderer } = this.props;
        return tabs.map((tab, index)=>{
            const { tabLabel, textAndAsset, tabClassName, isDisabled, tabDisabledColor } = tab;
            const { titleSize } = textAndAsset || {};
            return /*#__PURE__*/ _jsx(VerticalTab, {
                tabClassName: tabClassName,
                isDisabled: isDisabled,
                label: tabLabel,
                disabledColor: tabDisabledColor,
                color: tabsColor,
                addTimeline: addTimeline,
                isDarkTheme: isDarkTheme,
                lineColor: lineColor,
                children: tabContentRenderer ? tabContentRenderer(tab) : /*#__PURE__*/ _createElement(SideBySideTextAndAsset, _object_spread_props(_object_spread({}, textAndAsset), {
                    titleSize: titleSize || XS,
                    key: index
                }))
            }, tabLabel);
        });
    }
    render() {
        const { title, titleSize, tabsColor, tabsPosition, tabsTitleRenderer } = this.props;
        const positionStyles = getImagePositionStyles(tabsPosition);
        return /*#__PURE__*/ _jsxs(StyledVerticalTabsDesktopComponent, {
            positionStyles: positionStyles,
            className: "vertical-tabs-desktop-component",
            children: [
                tabsTitleRenderer ? tabsTitleRenderer() : /*#__PURE__*/ _jsx("div", {
                    className: "vertical-tabs-title-wrapper",
                    children: /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({}, title), {
                        titleSize: titleSize
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "vertical-tabs-wrapper",
                    role: "tablist",
                    children: /*#__PURE__*/ _jsx(VerticalTabs, _object_spread_props(_object_spread({}, this.props), {
                        color: tabsColor,
                        positionStyles: positionStyles,
                        children: this.tabsRenderer()
                    }))
                })
            ]
        });
    }
}
export { VerticalTabsDesktopComponent as default };
